export interface ISelectValue{
    label:string,
    value?:any,
    type?:number,
}

export interface ILegendData{ //quantidade de labels e colors deve ser igual
    title:string,
    labels:Array<string>,
    colors:Array<string>
}

export const tipos_planta_origin: Array<ISelectValue> = [
    { label: 'Folha larga', value:'Broadleaf' },
    { label: 'Folha estreita', value:'Grass' }
]
/*
export const generos_origin: Array<ISelectValue> = [
    { label: 'Eleusine', value:'Eleusine' },
    { label: 'Amaranthus', value:'Amaranthus' },
    { label: 'Lolium', value:'Lolium' },
    { label: 'Chloris', value:'Chloris' },
    { label: 'Bidens', value:'Bidens' },
    { label: 'Conyza', value:'Conyza' },
    { label: 'Echinochloa', value:'Echinochloa' },
    { label: 'Digitaria', value:'Digitaria' },
    { label: 'Euphorbia', value:'Euphorbia' },
    { label: 'Sorghum', value:'Sorghum' }
]
*/	
export const herbicidas_origin: Array<ISelectValue> = [
    { label: 'Clethodim', value:'1' },
    { label: 'Fenoxaprop', value:'2' },
    { label: 'Haloxyfop', value:'3' },
    { label: 'Iodosulfurom', value:'4' },
    { label: 'Ghyphosate', value:'5' },
    { label: 'Chlorimurom', value:'6' },
    { label: '2,4 D', value:'7' },
    { label: 'Diquat', value:'8' },
    { label: 'Saflufencil', value:'9' },
    { label: 'Glufosinate', value:'10' },
    { label: 'Paraquat', value:'11' },
    { label: 'Imazapyr', value:'12' },
    { label: 'Atrazine', value:'13' }
]   

export const mecanismos_acao_origin: Array<ISelectValue> = [
    { label: 'ACCase', value:'1' },
    { label: 'ALS', value:'2' },
    { label: 'EPSPS', value:'3' },
    { label: 'Growth Regulators', value:'4' },
    { label: 'Photosynthesis', value:'5' },
    { label: 'Protox', value:'6' },
    { label: 'Glutamine', value:'7' }
]
    
export const multiplos_mecanismos_origin: Array<ISelectValue> = [
    { label: 'Resistência simples', value:'Single_Resistant' },
    { label: 'Resistência múltipla', value:'Multiplie_Resistance' }
]

export const anos_origin: Array<ISelectValue> = [
    { label: '2018', value:'2018' },
    { label: '2019', value:'2019' },
    { label: '2020', value:'2020' }
]

export const especies_origin: Array<ISelectValue> = [ //Folha estreita: 1, Folha larga: 2
    { label: 'Chloris Polydacta', value:'Chloris Polydacta', type:1 },
    { label: 'Conyza spp.', value:'Conyza spp.', type:2 },
    { label: 'Lolium multiflorum', value:'Lolium multiflorum', type:1  },
    { label: 'Euphorbia heterophylla', value:'Euphorbia heterophylla', type:2 },
    { label: 'Sorghum arundinaceum', value:'Sorghum arundinaceum', type:1  },
    { label: 'Amaranthus spp.', value:'Amaranthus spp.', type:2 },
    { label: 'Echinochloa crus-galli', value:'Echinochloa crus-galli', type:1  },
    { label: 'Digitaria insularis', value:'Digitaria insularis', type:1  },
    { label: 'Bidens spp.', value:'Bidens spp.', type:2},
    { label: 'Eleusine indica', value:'Eleusine indica', type:1  },
]

export const respostas_erva_origin: Array<ISelectValue> = [
    { label: 'Suscetível', value:'Susceptible' },
    { label: 'Resistente', value:'Resistant' }
]

export const legenda_padrao: ILegendData = {
    title: 'Legenda',
    labels: ['Suscetível','Resistência simples','Resistência Múltipla'],
    colors:  ['#4daf4a','#FFD700','#de2d26']
}

export const legenda_algodao: ILegendData = {
    title: 'Área Plantada de algodão',
    labels: ['1 - 5284','5284 - 17779','17779 - 34893','34893 - 68487','68487 - 125194','125194 - 198843'],
    colors:  ['#ffffff','#cfccff','#9e99ff','#6e66ff','#3d33ff','#0c00ff']
}

export const legenda_arroz: ILegendData = {
    title: 'Área Plantada de arroz',
    labels: ['1 - 3350','3350 - 11608','11608 - 25522','25522 - 53105','53105 - 76319'],
    colors:  ['#ffffff','#fde6c7','#facc8f','#f8b257','#f5991f']
}

export const legenda_cana: ILegendData = {
    title: 'Área Plantada de cana',
    labels: ['1 - 4620','4620 - 16673','16673 - 36000','36000 - 67200','67200 - 99000'],
    colors:  ['#ffffff','#e8bfde','#d080bd','#b9409c','#a1007b']
}

export const legenda_milho: ILegendData = {
    title: 'Área Plantada de milho',
    labels: ['1 - 1000','1000 - 16500','16500 - 92000','92000 - 288000','288000 - 468622'],
    colors:  ['#ffffff','#c0bfc9','#808092','#40405b','#010025']
}

export const legenda_soja: ILegendData = {
    title: 'Área Plantada de soja',
    labels: ['1 - 16730','16730 - 57200','57200 - 138000','138000 - 287000','287000 - 605000'],
    colors:  ['#ffffff','#ffbfbf','#ff8080','#ff4040','#ff0000']
}

export const legenda_trigo: ILegendData = {
    title: 'Área Plantada de trigo',
    labels: ['3 - 1600','1600 - 4550','4550 - 9470','9470 - 18000','18000 - 33000'],
    colors:  ['#ffffff','#d3bfbf','#a68080','#794040','#4c0000']
}